<!-- vue快捷创建组件 -->
<template>
  <el-select :disabled="disabled" :value="valueTitle" :clearable="clearable" @clear="clearHandle" :placeholder="placeholder">
    <el-option :value="valueTitle" :label="valueTitle">
      <el-tree  id="tree-option"
                ref="selectTree"
                :accordion="accordion"
                :data="options"
                :props="props"
                :node-key="props.value"
                :default-expanded-keys="defaultExpandedKey"
                @node-click="handleNodeClick"
                >
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: "el-tree-select",
    props:{
      /* 配置项 */
      props:{
        type: Object,
        default:()=>{
          return {
            value:'id',             // ID字段名
            label: 'text',         // 显示名称
            children: 'children'    // 子级字段名
          }
        }
      },
      /* 选项列表数据(树形结构的对象数组) */
      options:{
        type: Array,
        default: ()=>{ return [] }
      },
      /* 初始值 */
      value:{
        // type: Number,
        default: ()=>{ return null }
      },
      /* 可清空选项 */
      clearable:{
        type:Boolean,
        default:()=>{ return false }
      },
       /* 不可选 */
      disabled:{
        type:Boolean,
        default:()=>{ return false }
      },
      /* 自动收起 */
      accordion:{
        type:Boolean,
        default:()=>{ return false }
      },
      /* 占位文字 */
      placeholder: {
        type: String,
        default: ()=>{ return '请选择' }
      }
    },
    data() {
      return {
        valueId:this.value,    // 初始值
        valueTitle:'',
        defaultExpandedKey:[],
        //是否为首次触发点击函数
        isFirstCallClick:true
      }
    },
    mounted(){
      this.initHandle(true);
    },
    methods: {
      // 初始化值
      initHandle(componentInit){
        this.$nextTick(()=>{
          let data = {};
          this.valueTitle = "";
          if(this.options.length > 0 && this.valueId){
            let node = this.$refs.selectTree.getNode(this.valueId);
            data =  {};
            data[this.props.label] = '';
            data[this.props.value] = '';
            if(node){
              data = node.data;
            }
            this.valueTitle = data[this.props.label]     // 初始化显示
            this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
            this.defaultExpandedKey = [this.valueId]      // 设置默认展开
            //触发一波点击
            this.handleNodeClick(data,componentInit);
          }
          // else if(!componentInit && !this.valueId){
          //   //触发一波点击
          //   this.handleNodeClick(data,componentInit);
          // }


          let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
          let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
          scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
          scrollBar.forEach(ele => ele.style.width = 0)
        })

      },
      // 切换选项
      handleNodeClick(node,componentInit){
        this.valueTitle = node[this.props.label]
        this.valueId = node[this.props.value]
        this.$emit('getValue',{
          id: this.valueId,
          text: this.valueTitle
        },componentInit);
        this.defaultExpandedKey = []
      },
      // 清除选中
      clearHandle(){
        this.valueTitle = ''
        this.valueId = null
        this.defaultExpandedKey = []
        this.clearSelected()
        this.$emit('getValue',{id:'',text:''})
      },
      /* 清空选中样式 */
      clearSelected(){
        let allNode = document.querySelectorAll('#tree-option .el-tree-node')
        allNode.forEach((element)=>element.classList.remove('is-current'))
      }
    },
    watch: {
      value(newVal,oldVal){
        //如果新值与 旧值一样,不触发此函数
        if(newVal == oldVal){
          return;
        }
        if(!newVal){
          //如果该值无效,清空选择
          this.clearHandle();
          return;
        }
        this.valueId = newVal;
        this.initHandle(false);
      },
      options(){
        //初始化选中值
        this.initHandle(false);
      }
    },
  };
</script>

<style scoped>
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 274px;
    padding: 0;
    line-height: 28px;
    overflow: hidden;
    overflow-y: auto;
  }

  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #5D8C82;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }
</style>




// WEBPACK FOOTER //
// src/components/common/selectTree.vue